import { createContext } from "react";

const UsersLogsContext = createContext();

export default UsersLogsContext;
